import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions, formatDateAndTime } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "title",
		headerName: "Title",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "description",
		headerName: "Description",
		minWidth: 350,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "code",
		headerName: "Code",
		minWidth: 150,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "active",
		headerName: "Active",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	{
		field: "startDate",
		headerName: "Start Date",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params: GridValueGetterParams) => {
			const startDate = formatDateAndTime(params);
			return startDate;
		},
	},
	{
		field: "endDate",
		headerName: "End Date",
		minWidth: 250,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params: GridValueGetterParams) => {
			const endDate = formatDateAndTime(params);
			return endDate;
		},
	},
	{
		field: "discountPercent",
		headerName: "Discount Percent",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => (Number(params.value) * 100).toFixed(2) + "%",
	},
	{
		field: "tags",
		headerName: "Tags",
		minWidth: 220,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value.length ? params.value.join(", ") : "--",
	},
	{
		field: "activeDays",
		headerName: "Active Days",
		minWidth: 150,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "allowUpdateDuringActivePeriod",
		headerName: "Allow Update During Active Period",
		minWidth: 270,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},

	...createdAtmodifiedAtActions
];
